module.exports = __webpack_public_path__ + "static/media/withdraw.10cd4dea.svg";


//////////////////
// WEBPACK FOOTER
// ./src/medias/withdraw.svg
// module id = 459
// module chunks = 0